// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 895) return "895/895.134064edf17b98c807ed.min.css";
	if (chunkId === 57) return "index.a49b83ef200c987a52d5.min.css";
	// return url for filenames based on template
	return undefined;
};